export default "__VITE_ASSET__BOlA5FIP__"